var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeInvisibleFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7077 13.4532C12.8006 13.553 12.9341 13.6 13.0561 13.6C13.3173 13.6 13.5379 13.371 13.5379 13.1067C13.5379 12.9775 13.4857 12.8424 13.3928 12.7484L3.29699 2.54098C3.19829 2.44701 3.07638 2.40002 2.96027 2.40002C2.69902 2.40002 2.4668 2.62908 2.4668 2.89336C2.4668 3.02845 2.50744 3.15765 2.60613 3.24575L12.7077 13.4532ZM13.2481 11.5151C15.0014 10.2994 15.9999 8.74888 15.9999 8.07935C15.9999 6.88711 12.8765 2.96975 7.99992 2.96975C7.01298 2.96975 6.09571 3.14007 5.25391 3.41611L7.00137 5.17804C7.31486 5.06057 7.65158 4.99597 8.00572 4.99597C9.69513 4.99597 11.071 6.3644 11.071 8.07935C11.071 8.44348 11.0072 8.78412 10.8853 9.10127L13.2481 11.5151ZM8 13.1889C9.03338 13.1889 9.9971 13.0127 10.8621 12.7132L9.10305 10.9337C8.77213 11.0864 8.39477 11.1627 8.00581 11.1627C6.30479 11.1627 4.93469 9.75317 4.93469 8.07934C4.93469 7.67997 5.01016 7.29235 5.1611 6.94583L2.8447 4.60247C1.0508 5.8182 0 7.39806 0 8.07934C0 9.26571 3.18723 13.1889 8 13.1889ZM9.87537 7.96185C9.87537 6.94581 9.0626 6.1177 8.05244 6.1177C8.0118 6.1177 7.97697 6.12357 7.93633 6.12945L9.86376 8.07932C9.86957 8.0382 9.87537 8.00296 9.87537 7.96185ZM6.11328 8.04994C6.11328 8.00882 6.11328 7.96184 6.11909 7.92073L8.05813 9.88822L7.93621 9.89409C6.93186 9.89409 6.11328 9.06598 6.11328 8.04994Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeInvisibleFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EyeInvisibleFilled.0651f93a4c799af3aefa8e2c5f86a7f8.svg";